import { Box, Button, Icon } from "@mui/material";
import HubspotLogo from "../../../../../../assets/hubspot.svg";
import { useClientDetails } from "../../../context/clientDetailsContext";

const LinkToHubspotButton = () => {
  const { linkToHubspot } = useClientDetails();

  return (
    <Box>
      <Button
        fullWidth
        startIcon={
          <Icon>
            <Box
              component="img"
              src={HubspotLogo}
              sx={{ width: "100%", verticalAlign: "top" }}
              alt="HubSpot Logo"
            />
          </Icon>
        }
        variant="contained"
        onClick={() => linkToHubspot.link()}
        loading={linkToHubspot.loading}
        loadingPosition="start"
      >
        Link to Hubspot
      </Button>
    </Box>
  );
};

export default LinkToHubspotButton;
